<template>
  <div class="dialog-mask" @click.self="$emit('close')">
    <div class="dialog-container max-w-[612px] w-full">
      <div class="title-wrap">
        <div class="title">{{ $t("front.login.title") }}</div>
        <div class="close-wrap" @click="$emit('close')">
          <div class="close"></div>
        </div>
      </div>
      <div class="pt-[25px] pb-[50px] text-[16px]">
        <div class="grid grid-cols-1 gap-y-[26px]">
          <div class="input-wrap">
            <p class="mb-4"><span class="text-main">* </span>{{ 12 }}</p>
            <input v-model="loginForm.account" type="text" class="input-style text-[14px] lg:text-[16px]"
              placeholder="請填寫登入帳號" />
          </div>
          <button class="
            w-full
            h-[42px]
            text-center text-white
            rounded
            bg-main           
            duration-200   
          " >
            {{ 123 }}
          </button>
          <div class="flex items-center justify-between text-sm">
            <p class="
            hover:text-main
            text-[#c7c7c7]
            duration-[800ms]
            cursor-pointer
            hover:tracking-[0.5px]
             ">{{ 13 }}</p>
            <p class="
            hover:text-main
            text-[#c7c7c7]
            duration-[800ms]
            cursor-pointer
            hover:tracking-[0.5px]
             ">{{ 12 }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Concept',
  setup() {

  }
}
</script>
